module.exports = __webpack_public_path__ + "static/3-4209418beffb6801b3bd166bb87075c5.jpg";